export default __webpack_public_path__ + "static/media/floorplan2.7ff26d92.svg";